module.exports = __webpack_public_path__ + "img/zln_5_mobile.10fde5ff.jpg";